module.exports = __webpack_public_path__ + "img/vitamina-D.fdd37642.png";